import Vue from 'vue';
import Router from 'vue-router';
import LoginPage from '@/views/LoginPage.vue';
import HomePage from '@/views/HomePage.vue';


Vue.use(Router);

const routes = [
  {
    path: '/',
    redirect:'/home', // Home
  },
  {
    path: '/login',
    name: 'LoginPage',
    component: LoginPage
  },
  {
    path: '/home',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/BillDetails',
    name: 'BillDetails',
    component:() => import("@/views/BillDetails.vue")
  },
  {
    path: '/MinePage',
    name: 'MinePage',
    component:() => import("@/views/MinePage.vue")
  },
  {
    path: '/MinePromoCode',
    name: 'MinePromoCode',
    component:() => import("@/views/MinePromoCode.vue")
  },
  {
    path: '/PosterPage',
    name: 'PosterPage',
    component:() => import("@/views/PosterPage.vue")
  },

];

const router = new Router({
  mode: 'history',
  routes
});

export default router;
